var _ellipse, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNoDataIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 126,
  height: 79,
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 63,
  cy: 66.5,
  rx: 63,
  ry: 12.5,
  fill: "#F5F5F5"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 27 40 1h46l22 26v34.5a8 8 0 0 1-8 8H26a8 8 0 0 1-8-8V27Z",
  fill: "#fff"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 27 40 1h46l22 26m-90 0v34.5a8 8 0 0 0 8 8h74a8 8 0 0 0 8-8V27m-90 0h21.198a4 4 0 0 1 3.76 2.633L46 38h34l2.196-8.052A4 4 0 0 1 86.056 27H108",
  stroke: "#D9D9D9",
  strokeWidth: 1.8
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M26 69h74a8 8 0 0 0 8-8V27H84.649a4 4 0 0 0-3.983 3.634l-.248 2.695a5 5 0 0 1-4.98 4.542H51.562a5 5 0 0 1-4.979-4.542l-.248-2.695A4 4 0 0 0 42.351 27H18v34a8 8 0 0 0 8 8Z",
  fill: "#FAFAFA",
  stroke: "#D9D9D9",
  strokeWidth: 1.8
})));
export default SvgNoDataIcon;